export default __webpack_public_path__ + "static/media/button_goback_en.3740404a.svg";